module.exports = __webpack_public_path__ + "img/instagram-Icon.dee652ec.svg";